import { html } from "lit-element";

import { StatefulModule } from "../ModuleBase/ModuleMetadata.js";
export class DrawGridModule extends StatefulModule {
	render() {
		return html`
    <style>

    mwc-button{
        margin: 0px 5px;
        --mdc-theme-on-primary: var(--primary-color);
        --mdc-theme-primary: var(--primary-color-variant1);
        --mdc-theme-on-secondary: var(--primary-color);
        --mdc-theme-secondary: var(--primary-color-variant1);
    }

    *[active]{
      background-color: var(--secondary-color);
    }
    </style>
   

    	<mwc-button ?active="${this.isGridVisible}" @click="${e => this.toggleGrid(e)}" >Grid</mwc-button>`;
	}

	static get properties() {
		return { isGridVisible: Boolean };
	}

	constructor(canvas, drawingHistory) {
		super();
		this.drawingHistory = drawingHistory;
		this.neverSelect = true;
		this.canvas = canvas;
		this.isGridVisible = false;
		this.moduleName = "grid";
	}

	toggleGrid() {
		this.isGridVisible = !this.isGridVisible;
		this.isGridVisible ? this.showGrid() : this.hideGrid();
	}

	showGrid() {

		let options = {
			distance: 10,
			width: this.canvas.initialSize.w,
			height: this.canvas.initialSize.h,
			param: {
				stroke: '#ebebeb',
				strokeWidth: 1,
				selectable: false
			}
		};
		let gridLen = options.width / options.distance;
		let gridHigh = options.height / options.distance;
		let lines = [];

		for (var i = 0; i < gridHigh; i++) {
			var distance = i * options.distance,
					horizontal = new fabric.Line([0, distance, options.width, distance], options.param);

			lines.push(horizontal);

			if (i % 5 === 0) {
				horizontal.set({ stroke: '#cccccc' });
			};
		}

		for (var i = 0; i < gridLen; i++) {
			var distance = i * options.distance,
					vertical = new fabric.Line([distance, 0, distance, options.height], options.param);

			lines.push(vertical);
			if (i % 5 === 0) {
				vertical.set({ stroke: '#cccccc' });
			};
		}


		let group = new fabric.Group(lines, {
			//top: 0,
			//left: 0,
			cursor: "cross",
			hasBorders: false,
			hasControls: false,
			selectable: false
		});


		this.addMetadata(group, { neverSelect: true, alwaysBack: true });

		this.canvas.add(group);
		this.canvas.sendToBack(group)
		this.canvas.renderAll();

	}

	updateState() {
		let found = false;
		this.canvas.forEachObject(o => {
			found = found || (o.moduleName && o.moduleName === this.constructor.name);
		});
		this.isGridVisible = found;
	}

	hideGrid() {
		this.canvas.forEachObject(o => {
			if (o.moduleName && o.moduleName === this.constructor.name) {
				this.canvas.remove(o);
			}
		});
	}
}

window.customElements.define("inspx-draw-grid", DrawGridModule);
